import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Input,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import { HashLink } from "react-router-hash-link";

//Import Icons
import FeatherIcon from "feather-icons-react";

// import images
import americanEx from "../../assets/images/payments/american-ex.png";
import discover from "../../assets/images/payments/discover.png";
import masterCard from "../../assets/images/payments/master-card.png";
import paypal from "../../assets/images/payments/paypal.png";
import visa from "../../assets/images/payments/visa.png";

//Import Images
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grid1: [
        { title: "About us", link: "#aboutus" },
        { title: "Highlights", link: "#highlights" },
        { title: "Features", link: "#features" },
        // { title: 'Pricing', link: '#' },
        // { title: 'Project', link: '#' },
        // { title: 'Careers', link: '#' },
        // { title: 'Blog', link: '#' },
        // { title: 'Login', link: '#' },
      ],
      grid2: [
        { title: "Terms of Services", link: "" },
        { title: "Privacy Policy", link: "" },
        // { title: 'Documentation', link: '#' },
        // { title: 'Changelog', link: '#' },
        // { title: 'Components', link: '#' },
      ],
      paymentCardData: [
        {
          img: americanEx,
          title: "American Express",
        },
        {
          img: discover,
          title: "Discover",
        },
        {
          img: masterCard,
          title: "Master Card",
        },
        {
          img: paypal,
          title: "Paypal",
        },
        {
          img: visa,
          title: "Visa",
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <Container id="contact">
            <Row>
              <Col className="col-12">
                <div
                  className={
                    this.props.isBorderLine
                      ? "footer-py-60 footer-border"
                      : "footer-py-60"
                  }
                >
                  <Row>
                    <Col lg={4} className="col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                      {/* <Link to="#" className="logo-footer">
                        <img
                          src={this.props.isLight ? logodark : logolight}
                          height="24"
                          alt=""
                        />
                      </Link> */}
                      {/* <p
                        className={
                          this.props.isLight ? 'mt-4 text-muted' : 'mt-4'
                        }
                      >
                        Start working with Landrick that can provide everything you need to generate awareness, drive traffic, connect.</p> */}
                      {/* <ul
                        className={
                          this.props.isLight
                            ? 'list-unstyled social-icon social mb-0 m t-4'
                            : 'list-unstyled social-icon foot-social-icon mb-0 mt-4'
                        }
                      >
                        <li className="list-inline-item me-1">
                          <Link to="#" className="rounded">
                            <FeatherIcon
                              icon="facebook"
                              className="fea icon-sm fea-social"
                            />
                          </Link>
                        </li>
                        <li className="list-inline-item me-1">
                          <Link to="#" className="rounded">
                            <FeatherIcon
                              icon="instagram"
                              className="fea icon-sm fea-social"
                            />
                          </Link>
                        </li>
                        <li className="list-inline-item me-1">
                          <Link to="#" className="rounded">
                            <FeatherIcon
                              icon="twitter"
                              className="fea icon-sm fea-social"
                            />
                          </Link>
                        </li>
                        <li className="list-inline-item me-1">
                          <Link to="#" className="rounded">
                            <FeatherIcon
                              icon="linkedin"
                              className="fea icon-sm fea-social"
                            />
                          </Link>
                        </li>
                      </ul> */}
                    </Col>

                    {/* <Col
                      lg={2}
                      md={4}
                      className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
                    > */}
                    {/* <h5
                        className={
                          this.props.isLight
                            ? 'text-dark footer-head'
                            : 'text-light footer-head'
                        }
                      >
                        Company
                      </h5>
                      <ul className="list-unstyled footer-list mt-4">
                        {this.state.grid1.map((grid, key) => (
                          <li key={key}>
                            <Link
                              to={grid.link}
                              className={
                                this.props.isLight ? 'text-muted' : 'text-foot'
                              }
                            >
                              <i className="uil uil-angle-right-b me-1"></i>{' '}
                              {grid.title}
                            </Link>
                          </li>
                        ))}
                      </ul> */}
                    {/* </Col> */}

                    {/* <Col
                      lg={3}
                      md={4}
                      className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
                    >
                      <h5
                        className={
                          this.props.isLight
                            ? 'text-dark footer-head'
                            : 'text-light footer-head'
                        }
                      >
                        Usefull Links
                      </h5>
                      <ul className="list-unstyled footer-list mt-4">
                        {this.state.grid2.map((grid, key) => (
                          <li key={key}>
                            <Link
                              to={grid.link}
                              className={
                                this.props.isLight ? 'text-muted' : 'text-foot'
                              }
                            >
                              <i className="uil uil-angle-right-b me-1"></i>{' '}
                              {grid.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </Col> */}

                    {/* <Col lg={4} md={2} className="ps-md-3 pe-md-3 mt-4 pt-2">
                <Card className="map map-height-two rounded map-gray border-0">
                  <CardBody className="p-0">
                    <iframe
                      title="test"
                      src="//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin"
                      style={{ border: 0 }}
                      className="rounded"
                      allowFullScreen=""
                    ></iframe>
                  </CardBody>
                </Card>
              </Col> */}

                    {/* <Col lg={3} md={4} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                      <h5
                        className={
                          this.props.isLight
                            ? 'text-dark footer-head'
                            : 'text-light footer-head'
                        }
                      >
                        Newsletter
                      </h5>
                      <p className="mt-4">Sign up and receive the latest tips via email.</p>
                      <Form>
                        <Row>
                          <Col lg={12}>
                            <div
                              className={
                                this.props.isLight
                                  ? 'foot-subscribe mb-3 foot-white'
                                  : 'foot-subscribe mb-3'
                              }
                            >
                              <Label
                                className={
                                  this.props.isLight
                                    ? 'form-label text-muted'
                                    : 'form-label'
                                }
                              >
                                Write your email {' '}
                                <span className="text-danger">*</span></Label>
                              <div className="form-icon position-relative">
                                <FeatherIcon
                                  icon="mail"
                                  className="fea icon-sm icons"
                                />
                                <Input
                                  type="email"
                                  name="email"
                                  id="emailsubscribe"
                                  className={
                                    this.props.isLight
                                      ? 'form-control ps-5 rounded bg-light border'
                                      : 'form-control ps-5 rounded'
                                  }
                                  placeholder="Your email : " required />
                              </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div className="d-grid">
                              <input
                                type="submit"
                                id="submitsubscribe"
                                name="send"
                                className={this.props.isLight ? "btn btn-primary" : "btn btn-soft-primary"}
                                value="Subscribe" />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </Col> */}
                    {/* <Col
                      lg={3}
                      md={4}
                      className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
                    >
                      <div className="title-heading ms-lg-4">
                        <h4 className="mb-4">Contact Details</h4>
                        <p className="text-muted">
                    At{" "}
                    <span className="fw-bold" style={{color:"#018ABF"}}>
                      Turtl
                    </span>{" "}
                    we provide everything you need to generate awareness,
                    drive traffic, connect.
                  </p>
                        <div className="d-flex contact-detail align-items-center mt-3">
                          <div className="icon">
                            <i>
                              <FeatherIcon
                                icon="mail"
                                className="fea icon-m-md text-dark me-3"
                              />
                            </i>
                          </div>
                          <div className="flex-1 content">
                            <h6 className="title fw-bold mb-0">Email</h6>
                            <Link
                              to="#"
                              onClick={this.sendMail}
                              className="text-primary "
                            >
                              connect@turtldelivery.com
                            </Link>
                          </div>
                        </div>

                        <div className="d-flex contact-detail align-items-center mt-3">
                          <div className="icon">
                            <i>
                              <FeatherIcon
                                icon="phone"
                                className="fea icon-m-md text-dark me-3"
                              />
                            </i>
                          </div>
                          <div className="flex-1 content">
                            <h6 className="title fw-bold mb-0">Phone</h6>
                            <Link
                              to="#"
                              onClick={this.callNumber}
                              className="text-primary "
                            >
                              +91 7483927043
                            </Link>
                          </div>
                        </div>

                        <div className="d-flex contact-detail align-items-center mt-3">
                          <div className="icon">
                            <i>
                              <FeatherIcon
                                icon="map-pin"
                                className="fea icon-m-md text-dark me-3"
                              />
                            </i>
                          </div>
                          <div className="flex-1 content">
                            <h6 className="title fw-bold mb-0">Location</h6>
                            <Link
                              to="https://maps.app.goo.gl/Yka35LBbFrzk8ur37"
                              className="video-play-icon  text-primary"
                              target="_blank"
                            >
                              View On Google
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Col> */}

                    <Container className="mt-100 mt-60">
                      <Row>
                        <h1 className="text-center" style={{marginBottom:'5%', marginTop:'-10%'}}>Reach Out To Us!</h1>
                        <Col md={4}>
                          <Card className="border-0 text-center features feature-primary feature-clean" style={{backgroundColor:'rgba(255, 255, 255, 0.0)'}}>
                            <div className="icons text-center mx-auto">
                              <i className="uil uil-phone d-block rounded h3 mb-0" style={{color: '#ffffff'}}></i>
                            </div>
                            <div className="content mt-4">
                              <h5 className="fw-bold">Phone</h5>
                              {/* <p className="text-muted">
                                Start working with Landrick that can provide
                                everything
                              </p> */}
                              <Link
                                to="#"
                                onClick={this.callNumber}
                                // className="read-more"
                                style={{color:'#ffffff'}}
                              >
                                +91 7483927043
                              </Link>
                            </div>
                          </Card>
                        </Col>

                        <Col md={4} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                          <Card className="border-0 text-center features feature-primary feature-clean" style={{backgroundColor:'rgba(255, 255, 255, 0.0)'}}>
                            <div className="icons text-center mx-auto">
                              <i className="uil uil-envelope d-block rounded h3 mb-0" style={{color: '#ffffff'}}></i>
                            </div>
                            <div className="content mt-4">
                              <h5 className="fw-bold">Email</h5>
                              {/* <p className="text-muted">
                                Start working with Landrick that can provide
                                everything
                              </p> */}
                              <Link
                                to="#"
                                onClick={this.sendMail}
                                // className="read-more"
                                style={{color:'#ffffff'}}
                              >
                                connect@turtldelivery.com
                              </Link>
                            </div>
                          </Card>
                        </Col>

                        <Col md={4} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                          <Card className="border-0 text-center features feature-primary feature-clean" style={{backgroundColor:'rgba(255, 255, 255, 0.0)'}}>
                            <div className="icons text-center mx-auto">
                              <i className="uil uil-map-marker d-block rounded h3 mb-0" style={{color: '#ffffff'}}></i>
                            </div>
                            <div className="content mt-4">
                              <h5 className="fw-bold">Location</h5>
                              {/* <p className="text-muted">
                                C/54 Northwest Freeway, Suite 558
                                
                              </p> */}
                              <Link
                                to="https://maps.app.goo.gl/Yka35LBbFrzk8ur37"
                                // className="video-play-icon lightbox"
                                target="_blank"
                              >
                                View on Google map
                              </Link>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    </Container>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>

          <div className="footer-py-30 footer-bar">
            <Container className="text-center">
              <Row className="align-items-center">
                <Col sm={6}>
                  <div className="text-sm-start">
                    <p className="mb-0">
                      © {new Date().getFullYear()} Turtl{" "}
                      {/* <i className="mdi mdi-heart text-danger"></i> by {" "}
                      <Link
                        to="https://themesbrand.in/"
                        target="_blank"
                        className="text-reset"
                        rel="noopener noreferrer"
                      >
                        Themesbrand
                      </Link>. */}
                    </p>
                  </div>
                </Col>

                {/* <Col sm={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <ul className="list-unstyled text-sm-end mb-0 d-flex gap-1 flex-wrap justify-content-sm-end">
                    {this.state.paymentCardData.map((item, key) => (
                      <li className="list-inline-item" key={key}>
                        <Link to="#">
                          <img
                            src={item.img}
                            className="avatar avatar-ex-sm"
                            title={item.title}
                            alt=""
                          />
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col> */}
              </Row>
            </Container>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
